import { useState } from "react";
import { useStore, CAT_META } from "../store/Store";

// ─── NEW IN CARD ──────────────────────────────────────────────────────────────
// A simpler, calmer sibling of ShowcaseCard: solid color block, straight
// (non-wavy) photo panel, white caption band with the price. Matches the
// reference template's plainer "New In" card, in Matchwell's own palette.
export default function NewInCard({ p, onNav, accent }) {
  const { dispatch, wish, toggleWish, notify } = useStore();
  const [hovered, setHovered] = useState(false);
  const meta = CAT_META[p.category] || { emoji:"👗" };
  const disc = Math.round((1 - p.price / p.mrp) * 100);
  const wished = wish.includes(p.id);

  const addCart = (e) => {
    e.stopPropagation();
    dispatch({ type:"ADD", p:{ ...p, sc:p.colors?.[0]||"Default", ss:p.sizes?.[0]||"Free" } });
    notify(`${p.name} added!`);
    if (navigator.vibrate) navigator.vibrate(50);
  };

  return (
    <div
      onClick={()=>onNav("product", p.id)}
      onMouseEnter={()=>setHovered(true)}
      onMouseLeave={()=>setHovered(false)}
      style={{
        borderRadius:16, overflow:"hidden", cursor:"pointer",
        background:accent,
        boxShadow: hovered ? `0 18px 36px ${accent}4d` : `0 6px 18px ${accent}30`,
        transform: hovered ? "translateY(-5px)" : "translateY(0)",
        transition:"all 0.3s ease",
      }}>
      <div style={{ textAlign:"center", padding:"14px 12px 6px" }}>
        <div style={{ fontSize:9, fontWeight:700, letterSpacing:2, color:"rgba(255,255,255,0.75)", textTransform:"uppercase", marginBottom:2 }}>{meta.emoji} {p.category}</div>
      </div>

      <div style={{ position:"relative", height:230, margin:"2px 8px 0", borderRadius:"12px 12px 0 0", overflow:"hidden", background:"white", display:"flex", alignItems:"center", justifyContent:"center" }}>
        {p.img
          ? <img src={p.img} alt={p.name} style={{ width:"100%", height:"100%", objectFit:"contain", transition:"transform 0.5s ease", transform:hovered?"scale(1.05)":"scale(1)" }} loading="lazy"/>
          : <div style={{ width:"100%", height:"100%", display:"flex", alignItems:"center", justifyContent:"center", fontSize:48, opacity:0.25 }}>{meta.emoji}</div>
        }
        {disc > 0 && (
          <span style={{ position:"absolute", top:8, right:8, background:"#1a1a2e", color:"white", fontSize:9, fontWeight:800, padding:"3px 9px", borderRadius:20 }}>
            {disc}% OFF
          </span>
        )}
        <button onClick={e=>{ e.stopPropagation(); toggleWish(p.id); if(navigator.vibrate)navigator.vibrate(30); }}
          style={{ position:"absolute", top:8, left:8, background:"white", border:"none", borderRadius:"50%", width:26, height:26, fontSize:12, cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center", boxShadow:"0 2px 8px rgba(0,0,0,0.18)" }}>
          {wished ? "❤️" : "🤍"}
        </button>
      </div>

      <div style={{ background:"white", margin:"0 8px 8px", borderRadius:"0 0 10px 10px", padding:"10px 12px 12px", display:"flex", alignItems:"center", justifyContent:"space-between", gap:8 }}>
        <div style={{ minWidth:0 }}>
          <div style={{ fontWeight:700, fontSize:12.5, color:"#1a1a2e", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", marginBottom:2 }}>{p.name}</div>
          <div>
            <span style={{ fontSize:13.5, fontWeight:900, color:"#1a1a2e" }}>₹{p.price?.toLocaleString("en-IN")}</span>
            {p.mrp > p.price && <span style={{ fontSize:10, color:"#aaa", textDecoration:"line-through", marginLeft:5 }}>₹{p.mrp?.toLocaleString("en-IN")}</span>}
          </div>
        </div>
        {p.stock > 0 && (
          <button onClick={addCart} style={{ background:accent, color:"white", border:"none", width:28, height:28, borderRadius:"50%", fontSize:15, fontWeight:700, cursor:"pointer", flexShrink:0, lineHeight:1 }}>+</button>
        )}
      </div>
    </div>
  );
}
